import { Component, inject } from '@angular/core';
import { Entity } from '@app/core/model/entities/entity';
import { ChecksService } from '@app/features/main/views/organization-checks/checks.service';
import {
  ServerSideIndicatorStatusPanelComponent
} from '@app/shared/components/indicator-status-panel/server-side-indicator-status-panel/server-side-indicator-status-panel.component';
import { SelectParams } from '@app/shared/grid/datasource-utils';
import { IStatusPanelParams } from 'ag-grid-community';
import { merge, Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';

@Component({
  selector: 'checks-indicator-status-panel',
  templateUrl: '../indicator-status-panel.component.html',
  styleUrls: ['../indicator-status-panel.component.scss'],
  standalone: false
})
export class ChecksIndicatorStatusPanelComponent extends ServerSideIndicatorStatusPanelComponent {
  private checksService = inject(ChecksService);

  /**
   * Set gridApi and add listen for row updates.
   */
  public agInit(params: IStatusPanelParams<Entity>): void {
    super.agInit(params);

    merge(
      this.checksService.checkAdded$,
      this.checksService.checkUpdated$,
      this.checksService.checksDeleted$,
      this.checksService.checkRenewed$
    )
      .subscribe(() => this.updateIndicatorsValues());
  }

  /**
   * Get aggregation result.
   * @param selectParams The parameters for the query. These include filtering, and aggregating.
   * @return Observable<Entity> Result of the aggregation query.
   */
  protected getAggregationResult(selectParams: SelectParams): Observable<Entity> {
    return this.checksService.loadChecksPage(selectParams)
      .pipe(first(), map(checks => checks.first()));
  }
}
